define([
	"dojo/_base/lang",
	"csi/def",
	"csi/def/Action",
	"csi/view/PluginFactory",
	"csi/view/ToolbarPluginButton"
], function(lang,def,Action,PluginFactory,ToolbarPluginButton) {

	return PluginFactory.declare("slicerGraphSettings", ToolbarPluginButton, {
		constructor: function() {
			this.defAction = lang.mixin(new Action(), {
				m_id: "SlicerGraphSettings",
				m_typeControl: def.ACTION_ICON,
				m_class: "iconChart",
				m_onAction: "onActionSetValue",
				classController: "csi/slicer/ChartController"
			});
			this.defAction.resolve();
		},

		postCreate: function() {
			// summary: hook to 'showGraphs' attribute on the Slicer widget
			this.inherited(arguments);
			this.getView().watch("showGraphs", lang.hitch(this, this._onShowGraphsChanged));
		},

		enablePlugin: function(/*Context?*/ctx) {
			// summary: handled by watch function below
		},

		_onShowGraphsChanged: function(name, oldValue, newValue) {
			// summary: enable the widget if 'showGraphs' is true
			this._setDisabled(this, !newValue);
		}
	});
});